import ConvenioApi from '../../apis/Convenio';

export default {
    namespaced: true,
    state: {
        convenios: [],
        filters: null,
        file_name: null,
        paginated:{},
        
    },
    mutations: {
        set_convenios (state, data) {
            state.convenios = data;
        },
        set_filters (state, data) {
            state.filters = data;
        },
        set_file_name (state, value) {
            state.file_name = value;
        },
        set_paginated (state, data) {
            state.paginated =  data
        }
    },
    actions: {
        setFilters ({commit}, data) {
            commit('set_filters', data);
        },
        async getConvenios({commit, dispatch}, filters) {
            
            return await ConvenioApi.get_allPaginated(filters)
                .then( response => {
                    commit('set_paginated', {
                        ...response.data
                    })
                    commit('set_convenios', response.data.data)
                })
                .catch( error => {
                    if (error.response?.status === 401) return null
                    dispatch('notifications/store_notification', {
                        type: 'error',
                        message: 'Ocurrió un error al listar notas de crédito, vuelva a intentarlo.'
                    }, {root: true});
                })
        },
        async downloadExcel({commit, dispatch}, filters) {
            commit('set_file_name', null);
            return await ConvenioApi.downloadExcel(filters)
                .then( response => {
                    commit('set_file_name', response.data.file_name);
                })
                .catch( error => {
                    if (error.response?.status === 401) return null
                    dispatch('notifications/store_notification', {
                        type: 'error',
                        message: 'Ocurrió un error al descargar reporte de notas de crédito, vuelva a intentarlo.'
                    }, {root: true});
                })
        },
    }
}